import React, {useState, useEffect} from 'react'
import './App.css';
import MainContainer from './containers/MainContainer';
import Layout from './layouts/Layout';
import { Helmet } from 'react-helmet';

import { getSiteContents} from "./services/siteContents"
import FullScreenLoad from './components/PageLoading/FullScreenLoad/FullScreenLoad';
//Tracking
import TagManager from 'react-gtm-module'

function App() {
  const [siteContent, setSiteContent] = useState([])

  useEffect(() => {
    const fetchSiteContents = async () => {
      const siteContents = await getSiteContents();
      setSiteContent(siteContents)
    }
    fetchSiteContents()
    // eslint-disable-next-line
  }, [])


    const tagManagerArgs = {
      gtmId:"GTM-MSF5RBW"
  }
  TagManager.initialize(tagManagerArgs)
  //  {siteContent.length && console.log("siteContents3", siteContent[0].site_title)}
  

  return (
    <>
    {siteContent.length ? (
      <>
      <Layout siteContent={siteContent}>
      <Helmet>
      <meta charSet="utf-8" />
      <title>{ siteContent[0].site_title }</title>
      <link rel="icon" type="image/png" href={siteContent[0].favicon_url} sizes="16x16" />
      <meta name="description" content={siteContent[0].meta_description}/>
      <meta name="keywords" content={siteContent[0].meta_tags}></meta>
      <meta property="og:image" content={siteContent[0].og_image} />
      </Helmet>
      <MainContainer siteContent={siteContent} />
      </Layout>
      </>
      ): (
        <FullScreenLoad />
        )}
        
        </>
    );
  }


  // return (
  //   <Layout>
     
  //     <FullScreenLoad />
  
  //     </Layout>
  //   );
  // }
  
  export default App;